import { sharedEffects } from 'wt-front-shared';

export const coreEffects = [
  ...sharedEffects,
];
